import { render, staticRenderFns } from "./resultQuery.vue?vue&type=template&id=aff8e7bc&scoped=true&"
import script from "./resultQuery.vue?vue&type=script&lang=js&"
export * from "./resultQuery.vue?vue&type=script&lang=js&"
import style0 from "./resultQuery.vue?vue&type=style&index=0&id=aff8e7bc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff8e7bc",
  null
  
)

export default component.exports